import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import IframeWrapper from '../IframeWrapper';
import PsychometricTestStart from './PsychometricTestStart';
import PsychometricTestPersonalityLikert from './PsychometricTestPersonalityLikert';
import PsychometricTestInterestsIntro from './PsychometricTestInterestsIntro';
import PsychometricTestCheckBox from './PyschometricTestCheckbox';
import PsychometricTestSkillsIntro from './PsychometricTestSkillsIntro';
import PsychometricTestSkillsLikert from './PyschometricTestSkillsLikert';
import PsychometricTestConclusion from './PsychometricTestConclusion';
import {PsychometricContext} from '../../contexts/PsychometricContext';
import PsychometricService from '../../services/PsychometricService';

const steps = [
  'landing',
  'personalityLikert',
  'interestsIntro',
  'checkBox',
  'skillsIntro',
  'skillsLikert',
  'conclusion'
];

const PsychometricTestWrapper = ({ useIframe, ...props }) => {
  const themeContext = useContext(ThemeContext);
  const { 
    isOrganization, 
    setSignedID, 
    setSignedFirstName,
    setSignedLastName, 
    setSignedOrganization,
    setSignedEmail,
    setIsOrganization,
    setSignedMobile,
    setSignedPassword,
    setIsStudent,
    signedID,
    signedFirstName,
    signedLastName,
    signedOrganization,
    signedEmail 
  } = useContext(PsychometricContext);
  
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const { param1, param2, param3, param4 } = props.match.params;

  const clearAuthState = () => {
    setSignedEmail(null);
    setIsOrganization(null);
    setSignedFirstName(null);
    setSignedLastName(null);
    setSignedID(null);
    setSignedOrganization(null);
    setSignedMobile(null);
    setSignedPassword(null);
    setIsStudent(null);
    
    localStorage.removeItem('signedEmail');
    localStorage.removeItem('isOrganization');
    localStorage.removeItem('signedFirstName');
    localStorage.removeItem('signedLastName');
    localStorage.removeItem('signedId');
    localStorage.removeItem('signedOrganization');
    localStorage.removeItem('signedMobile');
    localStorage.removeItem('signedPassword');
    localStorage.removeItem('isStudent');
    
    sessionStorage.removeItem('psychometricTestStep');
    sessionStorage.removeItem('psychometricTestInProgress');
  };

  useEffect(() => {
 
    
    // Always reset to landing page
    setCurrentStep(0);
    sessionStorage.setItem('psychometricTestStep', '0');
    sessionStorage.setItem('psychometricTestInProgress', 'false');

    // Set context based on user type
    if (param1 && param2 && param3 && param4) {
      console.log("Setting up organization user");
      setIsOrganization(true);
      setSignedID(param1);
      setSignedFirstName(param2);
      setSignedLastName(param3);
      setSignedOrganization(param4);
      setIsInitialized(true);
      return;
    } else if (param1) {
      // Individual user
      setIsOrganization(false);
      setSignedEmail(param1);
      setIsInitialized(true);
      return;
    }

    console.log("Missing required parameters");
    history.push('/');

    return () => {
      if (!useIframe) {  // Only clear state if not in iframe
        console.log("PsychometricTestWrapper unmounting, clearing auth state");
        clearAuthState();
      }
    };
  }, [param1, param2, param3, param4]);

  // Don't render anything until we're initialized
  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  const getComponent = () => {
    switch (steps[currentStep]) {
      case 'landing':
        return PsychometricTestStart;
      case 'personalityLikert':
        return PsychometricTestPersonalityLikert;
      case 'interestsIntro':
        return PsychometricTestInterestsIntro;
      case 'checkBox':
        return PsychometricTestCheckBox;
      case 'skillsIntro':
        return PsychometricTestSkillsIntro;
      case 'skillsLikert':
        return PsychometricTestSkillsLikert;
      case 'conclusion':
        return PsychometricTestConclusion;
      default:
        return PsychometricTestStart;
    }
  };

  const goToNextStep = (e) => {
    if (e) e.preventDefault();
    console.log("goToNextStep called, current step:", currentStep);
    if (currentStep < steps.length - 1) {
      const nextStep = currentStep + 1;
      console.log("Setting next step to:", nextStep);
      setCurrentStep(nextStep);
      sessionStorage.setItem('psychometricTestStep', nextStep.toString());
      sessionStorage.setItem('psychometricTestInProgress', 'true');
      console.log("SessionStorage updated with step:", nextStep);
    } else {
      console.log("Test completed, currentStep:", currentStep);
      // Handle test completion (e.g., redirect to a results page)
      sessionStorage.removeItem('psychometricTestStep'); // Reset step on completion
      sessionStorage.removeItem('psychometricTestInProgress');
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      setCurrentStep(prevStep);
      sessionStorage.setItem('psychometricTestStep', prevStep.toString());
    }
  };

  const Component = getComponent();
  console.log("Rendering component for step:", steps[currentStep]);

  const componentProps = {
    params,
    history,
    location,
    goToNextStep,
    goToPreviousStep,
    isOrganization,
    signedID,
    signedFirstName,
    signedLastName,
    signedOrganization,
    signedEmail,
    ...props
  };

  const content = (
    <ThemeContext.Provider value={themeContext}>
      <Component {...componentProps} />
    </ThemeContext.Provider>
  );

  if (useIframe) {


    
    return (
      <IframeWrapper>
        {content}
      </IframeWrapper>
    );
  }

  return content;
};

export default PsychometricTestWrapper;
